<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import Dropdown from 'primevue/dropdown'
import {FabricStatusEnum, type Product} from '@/types/product-types'
import { getProductList } from '@/api/products'
import { useField } from 'vee-validate'

const props = defineProps<{
  modelValue?: Product | undefined
  inputName: string
  disabled?: boolean
}>()

const emit = defineEmits(['update:modelValue'])

const { value, errorMessage } = useField<Product | undefined>(props.inputName);

const computedValue = computed({
  get: () => value.value?.unfinishedReference,
  set: (newVal?: string) => {
    if (!newVal) return;
    const selectedProduct = qualities.value?.find(q => q.unfinishedReference === newVal);
    value.value = selectedProduct;
    emit('update:modelValue', selectedProduct);
  }
})

const qualities = ref<Product[]>();

onMounted(async () => {
  const allProducts = await getProductList()
  qualities.value = allProducts.filter(product => product.fabricStatus === FabricStatusEnum.Unfinished)
})


</script>

<template>
  <div class="flex flex-col gap-2">
    <label for="batchQuality">Batch Quality:</label>
    <Dropdown
      id="knittingQuality"
      v-model="computedValue"
      :options="qualities"
      :disabled="disabled"
      :invalid="!!errorMessage"
      option-label="unfinishedReference"
      option-value="unfinishedReference"
      aria-describedby="batch quality"
    />
  </div>
</template>

<style scoped>

</style>